import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchAdsWithoutPdfsProps = { startDate: Moment; endDate: Moment };

export type FetchAdsWithoutPdfs = (dates: FetchAdsWithoutPdfsProps) => void;

const fetchAdsWithoutPdfs = ({
  startDate,
  endDate,
}: FetchAdsWithoutPdfsProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport("ads_without_pdfs", dispatch, params);
};

export default fetchAdsWithoutPdfs;
